import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Search from '../../components/search/Search';
import Divider from '../../components/Divider';

const MembersActions = props => {
    const {
        onSearchChange,
        searchTerm,
        isAddMember,
        adminAction,
        classes,
    } = props;

    let search;
    if (!isAddMember) {
        search = (
            <Search
                value={searchTerm}
                onChange={onSearchChange}
                placeholder="Search members..."
            />
        );
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes.search}>
                <div className={classes.holder}>{search}</div>
            </div>
            {!isAddMember && <Divider horizontal />}
            <div className={classes.holder}>
                <div className={classes.actions}>{adminAction}</div>
            </div>
        </div>
    );
};

MembersActions.propTypes = {
    adminAction: PropTypes.object,
    searchTerm: PropTypes.string,
    onSearchChange: PropTypes.func.isRequired,
    isAddMember: PropTypes.bool.isRequired,
};

MembersActions.defaultProps = {
    adminAction: undefined,
    searchTerm: '',
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
    },
    search: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: spacing.maxActionComponentHeight,
    },
    holder: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: spacing.maxWidth,
    },
    actions: {
        marginTop: spacing.unit * 3,
    },
});

export default injectSheet(style)(MembersActions);



// WEBPACK FOOTER //
// ./src/components/members/MembersActions.js